import React, { useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Email, Message, Mobile, SubmitResetClearButton, Title } from './ClientUtil';
import { validateEmail, validateMobile } from './ClientValidate';
import { axiosErrorHandler, axiosGetWithHeader, axiosPostWithHeader, axiosResponseHandler, ShowAlertError } from '../Common/axios';
import Spinner from 'react-bootstrap/esm/Spinner';
import { SingleButton } from '../Login/LoginUtil';

export function ChangeCommunication (props) {
  const [data, setData] = useState([]);
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const emailReference = useRef();
  const mobileReference = useRef();
  const [errorAlert, setErrorAlert] = useState(null);
  const [success, setSuccess] = useState(false);
  const [spinner, setSpinner] = useState('Loading - Change Contact Details Page');
  const navigate = useNavigate();

  const init = () => {
    axiosGetWithHeader("/astrologer/getMobileAndEmail",
      (response)=>{
        setData(response.data);
        setEmail(response.data.email);
        setMobile(response.data.mobile);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setSpinner(null);
        setErrorAlert(error.message);
      }
    );
  }

  useMemo(() => {
    init();
  }, []);

  const handleBack = (event) => {
    setTimeout(() => {
      navigate('/profile.html', { replace: true });
    }, 100);
  }

  const handleInput = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    switch(name) {
      case 'email': setEmail(value); break;
      case 'mobile': setMobile(value); break;
      case 'message': setMessage(value); break;
      default : 
    }
  }

  const handleReset = (event) =>{
    const value="";
    setEmail(value);
    setMobile(value);
    setMessage(value);
    emailReference.current.focus();
  }

  const handleReset1 = (event) => {
    const value="";
    setEmail(data.email);
    setMobile(data.mobile);
    setMessage(value);
    emailReference.current.focus();
  }

  const handleSubmit = (event) => {
    var msg = '';
    if(msg==='') msg = validateEmail(event,emailReference,email);
    if(msg==='') msg = validateMobile(event,mobileReference,mobile);
    if(msg==='' && data.email===email && data.mobile===mobile) {
      msg = "You have not changed any value.";
    }
    setMessage(msg);

    if(msg==='') {
      const data = {
        email: email,
        mobile: mobile,
      }
      axiosPostWithHeader("/astrologer/changeMobileAndEmail", data,
        (response)=>{
          setMessage(axiosResponseHandler(response, emailReference, ()=>handleReset(), "Your email and mobile details updated successfully"));
          init();
          if(response.data.code==='200') {
            setSuccess(true);
          }
        },
        (error)=>{
          setMessage(axiosErrorHandler(emailReference,error));
          setErrorAlert(error.message);
        }
      );
    }
  
    event.preventDefault();
  }

  return(
    <>
      {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
      <div class="m-0 p-0 row align-items-top">
        <div class="col-sm-2 col-md-2 d-none d-md-block"></div>    
        <div class="col-sm-12 col-md-8 m-0 p-2 bg-white text-black">
          <Title title="Change email and mobile" urlcallback={handleBack}></Title>
          <div class="row m-0 p-0 w-100 border rounded">
            <div class="col m-0 p-0 justify-content-center">
              <div class="row m-0 p-0 w-100">
              <div class="col-3 d-none d-lg-block"></div>
              <div class="col-sm-12 col-lg-6">
                <Message msg={message} /> 
                {success===false?
                <form method="post" onSubmit={handleSubmit}>
                  <Email reference={emailReference} data={email} callback={handleInput} />
                  <Mobile reference={mobileReference} data={mobile} callback={handleInput} />
                  <SubmitResetClearButton callback={handleReset} callbackReset={handleReset1}/> 
                </form>
                : <SingleButton title="Ok" callback={handleBack}/>
                }
              </div>  
              <div class="col-3 d-none d-lg-block"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-2 col-md-2 d-none d-md-block"></div>    
        <ShowAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert}/>
      </div>
    </>
  );
}
